import React, { useState } from 'react';
import { StatsTable } from './StatsTable';
import { UploadedVideos } from './UploadedVideos';

export const StatsSection = ({
  hasFollowedPlayers = false,
  followedPlayers = [],
  activeProfileTab = 'players',
  teamRoster = [],
  teamRosterLoading = false,
  selectedTeam = null,
  teamRosterPagination = null,
  onLoadMoreRoster = () => { }
}) => {
  const [activeTab, setActiveTab] = useState('hitting');

  // Determine which data to show
  const showTeamRoster = activeProfileTab === 'teams' && selectedTeam;
  const hasTeamRoster = teamRoster && teamRoster.length > 0;

  // Don't render if no followed players and not showing team roster
  if (!hasFollowedPlayers && !showTeamRoster) {
    return null;
  }

  const getFilteredPlayers = () => {
    const baseData = showTeamRoster ? teamRoster : followedPlayers;

    if (activeTab === 'videos') {
      return baseData;
    }

    const isPitcher = (player) => {
      const position = player.position?.toUpperCase().trim() || '';
      return position.includes('RHP') || position.includes('LHP') || position === 'P' || position === 'PITCHER';
    };

    if (activeTab === 'pitching') {
      return baseData.filter(player => isPitcher(player));
    }

    if (activeTab === 'hitting') {
      return baseData.filter(player => !isPitcher(player));
    }

    return baseData;
  };

  // Data to display in table
  const displayData = getFilteredPlayers();

  return (
    <div className=" p-6 ">
      <h3 className="text-jp-ink text-lg font-bold mb-4 text-left uppercase">
        {showTeamRoster
          ? `${selectedTeam?.name || 'Team'} Roster - Player Stats`
          : 'STAY UP TO DATE WITH THE LATEST NEWS ABOUT THE PLAYERS YOU FOLLOW'}
      </h3>

      <div className="flex items-center gap-3 mb-6">
        <button
          onClick={() => setActiveTab('hitting')}
          className={`px-6 py-2.5 rounded-lg font-medium transition-colors ${activeTab === 'hitting'
            ? 'bg-cyan-500 text-white'
            : 'bg-jp-section text-jp-muted hover:text-jp-ink'
            }`}
        >
          HITTING STATS
        </button>
        <button
          onClick={() => setActiveTab('pitching')}
          className={`px-6 py-2.5 rounded-lg font-medium transition-colors ${activeTab === 'pitching'
            ? 'bg-cyan-500 text-white'
            : 'bg-jp-section text-jp-muted hover:text-jp-ink'
            }`}
        >
          PITCHING STATS
        </button>
        <button
          onClick={() => setActiveTab('videos')}
          className={`px-6 py-2.5 rounded-lg font-medium transition-colors ${activeTab === 'videos'
            ? 'bg-cyan-500 text-white'
            : 'bg-jp-section text-jp-muted hover:text-jp-ink'
            }`}
        >
          VIDEO UPLOADS
        </button>
      </div>

      {teamRosterLoading && teamRoster.length === 0 ? (
        <div className="flex items-center justify-center w-full py-12">
          <div className="w-8 h-8 border-2 border-cyan-500 border-t-transparent rounded-full animate-spin"></div>
        </div>
      ) : showTeamRoster && !hasTeamRoster ? (
        <div className="flex flex-col items-center justify-center w-full py-12 text-center">
          <p className="text-jp-muted text-lg font-medium mb-2">No players found in this team</p>
          <p className="text-jp-muted text-sm max-w-md">
            This team doesn't have any players in the roster yet.
          </p>
        </div>
      ) : (
        <>
          {activeTab === 'videos' ? (
            <UploadedVideos followedPlayers={displayData} />
          ) : (
            <StatsTable activeTab={activeTab} followedPlayers={displayData} />
          )}

          {/* Load More Button for Team Roster */}
          {showTeamRoster && teamRosterPagination && teamRosterPagination.hasMore && activeTab !== 'videos' && (
            <div className="flex justify-center mt-6">
              <button
                onClick={onLoadMoreRoster}
                disabled={teamRosterLoading}
                className="px-6 py-3 bg-cyan-500 hover:bg-cyan-600 text-white font-semibold rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
              >
                {teamRosterLoading ? (
                  <>
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    <span>Loading...</span>
                  </>
                ) : (
                  <>
                    <span>Load More Players</span>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                  </>
                )}
              </button>
            </div>
          )}

          {/* Pagination Info */}
          {showTeamRoster && teamRosterPagination && activeTab !== 'videos' && (
            <div className="flex justify-center mt-4">
              <p className="text-jp-muted text-sm">
                Showing {teamRoster.length} of {teamRosterPagination.totalCount} players
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
};
